module.exports = ".ck-content span[lang]{font-style:italic}"